var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3 12.58h-.9l-.33-.31a7.43 7.43 0 10-.8.8l.3.32v.9L18.3 20l1.7-1.7zm-6.87 0A5.14 5.14 0 117.42 2.3a5.14 5.14 0 01.01 10.28z"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--search-8b55a5d71e56144079c84499410dfdcc.svg";
export { SvgIconUiSearch as Component };